import React, { useState, useEffect } from 'react'
import { Banners, Checkdevice, Jfmodal, Leftrightbtn, Loading, Modcfm, Noti, Portalmodal } from '../../../../components'
import { iconwrapper, Retrieve_personal_info } from '../../../../config/commonfunctions'
import { READ_SCEDIT, REPLACE_SCDATA, UPDATE_SC, UPDATE_SINGLEGUEST, UPDATE_SINGLETABLE, RMV_SINGLEGUEST, UPDATE_SWAP, RMV_SINGLETABLE, UPDATE_TEMPLATE, DELETE_SCDATA, UPDATE_SCEDITRELATIONSHIP, UPDATE_SCEDITGROUP, UPDATE_SCEDITCATEGORY } from './../../../../config/api'
import { ARROWLEFT_ICON, ENGLISH_FF, hideseatcorner, LOOKUPUNSTYLE_ICON, ADDNEWUSER_SMALL, EMPTYSPACE, WEBSITE_URL, PLOBJ, STARTUP_NAME } from '../../../../config/constants'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { Addguestcontent, Addtablecontent, Editsingleguestcontent, Edittablecontent, Importcontent, Seatlayout } from './Components'
import { CSVDownloader } from 'react-papaparse'
import { Scdesign, Online } from './Components'
import { corners } from '../../../../assets/invitationcard/index1'
import { Togglebutton } from '../../../../basic_components'
import { input_dom, inputdescribe_dom, partialtitle_dom } from '../Invitationmaker/components/Commonelements/Commonelements'
import { COPY_ICON, CROSS_ICON, ENTER_ICON, SETTING_ICON, TICK_ICON, ITINERARYTEMPLATE_ICON, RELATIONSHIP_ICON, CAT_ICON, GRP_ICON } from '../../../../config/svgicons'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { Addcatcontent, Addgrpcontent, Addrelacontent } from '../Invitationmaker/components'
import './Seatchartedit.css'
import './../Planning.css'

// import { banners, corners_collection, flowers } from '../../../../assets/invitationcard'
// import { saveAs } from 'file-saver'
const tableiconcss = { width: 20, height: 20, marginLeft: 5, color: 'var(--donegreen)', display: 'flex' }
const tablecrossiconcss = { width: 20, height: 20, marginLeft: 5, color: 'red', display: 'flex' }
function copyToClipboard(string) {
    let textarea;
    let result;

    try {
        textarea = document.createElement('textarea');
        textarea.setAttribute('readonly', true);
        textarea.setAttribute('contenteditable', true);
        textarea.style.position = 'fixed'; // prevent scroll from jumping to the bottom when focus is set.
        textarea.value = string;

        document.body.appendChild(textarea);

        textarea.focus();
        textarea.select();

        const range = document.createRange();
        range.selectNodeContents(textarea);

        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);

        textarea.setSelectionRange(0, textarea.value.length);
        result = document.execCommand('copy');
    } catch (err) {
        console.error(err);
        result = null;
    } finally {
        document.body.removeChild(textarea);
    }

    // manual copy fallback using prompt
    if (!result) {
        const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
        const copyHotkey = isMac ? '⌘C' : 'CTRL+C';
        result = prompt(`Press ${copyHotkey}`, string); // eslint-disable-line no-alert
        if (!result) {
            return false;
        }
    }
    return true;
}

const tablesvg = <svg height="21" width="21" fill="inherit" style={{ display: 'inline-block', verticalAlign: 'middle' }} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20271"><path d="M512 106.666667C285.866667 106.666667 42.666667 155.733333 42.666667 266.666667v106.666666c0 104.533333 221.866667 155.733333 437.333333 160v192c-106.666667 4.266667-217.6 29.866667-217.6 96 0 70.4 134.4 96 251.733333 96s251.733333-25.6 251.733334-96c0-64-110.933333-91.733333-217.6-96V469.333333h-32c-266.666667 0-405.333333-68.266667-405.333334-96v-21.333333C194.133333 403.2 356.266667 426.666667 512 426.666667s317.866667-23.466667 405.333333-74.666667v21.333333c0 25.6-102.4 76.8-298.666666 91.733334v64c189.866667-12.8 362.666667-64 362.666666-155.733334v-106.666666C981.333333 155.733333 738.133333 106.666667 512 106.666667z m32 704v-21.333334c78.933333 4.266667 132.266667 19.2 149.333333 32-21.333333 12.8-83.2 32-181.333333 32s-162.133333-19.2-181.333333-32c19.2-10.666667 70.4-27.733333 149.333333-32v21.333334h64zM512 362.666667c-266.666667 0-405.333333-68.266667-405.333333-96S245.333333 170.666667 512 170.666667s405.333333 68.266667 405.333333 96S778.666667 362.666667 512 362.666667z" p-id="20272"></path></svg>
const NEW_ENGLISH_FF = ['', ...ENGLISH_FF]

const TABLE_MAX = 400
const GUEST_MAX = 2000
const MAX_GUEST_PER_TABLE = 101

const DEVICE_MODALWT_MAP = {
    'WEB': 500,
    'TABLET': 500,
}

const getTableStyle = isDraggingOver => ({
    backgroundColor: '#ffffff',
    width: '100%',
    height: '100%',
    minHeight: 289,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

});

const getGuestliststyle = isDraggingOver => ({
    backgroundColor: '#ffffff',
    width: 240,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
});

const Nomobile = () => {
    return <div style={{ display: 'flex', flexDirection: 'column', width: '100vw', height: '100vh', placeContent: 'center', alignItems: 'center' }}>
        <div style={{ padding: 10, display: 'flex', textAlign: 'center' }}>Sorry, this feature is currently only supported on a desktop or laptop and is not available on mobile devices.</div>
        <button id='itineraryedit_mobilebtmbtn' onClick={() => props.history.push('/')}>Home</button>
    </div>
}

const Modalsubtitle = (txt) => {
    return <div style={{ top: 60, position: 'fixed', border: '1px solid #707070', padding: '0px 5px', borderRadius: 5, marginBottom: 20, color: 'white', backgroundColor: '#707070' }}>
        {txt}
    </div>
}

const Extractpageprops = (data) => {
    // aligncanva: "center"
    // allseatnames: (4) ['<div>Prem Kumar</div><div>Shanti</div><div>Jun Kai…>Shabir</div><div>Shabir</div><div>Jia Ming</div>', '<div>Lim Jun Jie</div><div>Shantha</div><div>Jia W…>Haliq</div><div>Lim Jun Jie</div><div>Andy</div>', '<div>Yi Wei</div><div>Jonathan</div><div>Haliq</di…v>Haliq</div><div>Jonathan</div><div>Yi Wei</div>', '<div>Andy</div><div>Jia Wei</div><div>Mary</div><d…div>Haliq</div><div>Jia Ming</div><div>Mary</div>']
    // allseatnamescss: (4) [{…}, {…}, {…}, {…}]
    // alltablenames: (4) ['Table 1', 'Table 2', 'Table 3', 'Table 4']
    // alltablenamescss: (4) [{…}, {…}, {…}, {…}]
    // banner: `${S3CLOUD_CLOUDFRONT_ASSET}Inv/banner/0007.png`
    // cornerimg: "https://i.ibb.co/NCYsCFD/1000-1000-corner.png"
    // defaultmain: "Alice & Bob"
    // defaulttop: "SEATING ARRANGEMENT"
    // floralplacement: 0
    // jccanva: "flex-start"
    // maincss: {fontFamily: 'Dancing Script', fontStyle: '', fontSize: 80, fontWeight: 'bold', placeContent: 'center', …}
    // tablecss: "SMALL"
    // tableformat: "4_0"
    // template: 0
    // templatecolor: "#fffef8"
    // templatetype: "CLASSIC"
    // topcss: {fontFamily: 'Nanum Myeongjo', fontStyle: '', fontSize: 15, fontWeight: '', placeContent: 'center', …}
    // totaltables: 4
    if (data) {
        const {
            banner,
            cornerimg,
            defaultmain,
            defaulttop,
            topcss,
            maincss,
            alltablenamescss,
            allseatnamescss,
            floralplacement,
            template,
            templatecolor,
        } = data

        var tabletitlecss = alltablenamescss.length > 0 ? alltablenamescss[0] : null
        var seatscontainercss = allseatnamescss.length > 0 ? allseatnamescss[0] : null
        return {
            banner,
            cornerimg,
            defaultmain,
            defaulttop,
            topcss,
            maincss,
            tabletitlecss,
            seatscontainercss,
            floralplacement,
            template,
            templatecolor
        }
    }
    else {
        return {}
    }


}

function Seatchartedit(props) {

    const device = Checkdevice()
    const { token } = Retrieve_personal_info()
    const [firsttime, setFirsttime] = useState(true)
    const [load, setLoad] = useState(false)

    const [scid, setScid] = useState('')
    const [save_id, setSave_id] = useState('')
    const [uid, setUid] = useState('') // eslint-disable-line
    const [urlhandler, setUrlhandler] = useState('')
    const [pages, setPages] = useState([]) // pages data for PRINTING
    const [onlineselectedpg, setOnlineselectedpg] = useState(-1) // page design that online corners inherit
    const [onlineselectedpgprops, setOnlineselectedpgprops] = useState({}) // page design that online corners inherit
    const [onlineselectedsave, setOnlineselectedsave] = useState(false) // use to detect "Save and Preview" is clicked
    const [etype, setEtype] = useState('') // eslint-disable-line
    const [passcode, setPasscode] = useState('')
    const [name, setName] = useState('') // table name

    const [noti, setNoti] = useState('')
    const [swaptableindex, setSwaptableindex] = useState(-1)
    const [exceltableobjs, setExceltableobjs] = useState([])
    const [tableobjs, setTableobjs] = useState([])
    const [guests, setGuests] = useState([]) // { name: 'Name 1', rela: 'Husband', cat:'' },
    const [editedsignal, setEditedsignal] = useState(false) // prevent user from clicking preview if nt save

    const [ondrag, setOndrag] = useState(false)

    const [showaddtable, setShowaddtable] = useState(false) // add table modal
    const [showaddguest, setShowaddguest] = useState(false) // add guest modal
    const [showedittable, setShowedittable] = useState(false) // edit table modal
    const [edittabledata, setEdittabledata] = useState([])

    const [showeditsingleguest, setShoweditsingleguest] = useState(false) // edit non-seated guest modal
    const [editsingleguestdata, setEditsingleguestdata] = useState({})
    const [showeditseatedguest, setShoweditseatedguest] = useState(false) // edit seated guest modal
    const [editseatedguestdata, setEditseatedguestdata] = useState({})

    const [massmoveguests, setMassmoveguests] = useState([]) // massmove array

    const [showimport, setShowimport] = useState(false)
    const [showhelp, setShowhelp] = useState(false)
    const [edittype, setEdittype] = useState(0)

    const [showqr, setShowqr] = useState(false)
    const [showexport, setShowexport] = useState(false)

    const [imgs, setImgs] = useState(['', '', '']) // [ WEB device img , MOBILE device img, CORNER img]
    const [style, setStyle] = useState({ fontFamily: '' })

    const [bannermod, setBannermod] = useState(false)// banner modal

    const [selectedswapindex, setSelectedswapindex] = useState(-1)

    const [returnhome, setReturnhome] = useState(false)// var to return to planning home

    const [mode, setMode] = useState(0)// 0: edit mode, 1: design mode, 2: online mode, 3: layout mode

    const [showsetting, setShowsetting] = useState(false)

    const [showtemplate, setShowtemplate] = useState(false)
    const [template, setTemplate] = useState(-1)

    const [guestgrps, setGuestgrps] = useState([])
    const [showgrp, setShowgrp] = useState(false)
    const [addgrpmodalguestgrps, setAddgrpmodalguestgrps] = useState([])
    const [addgrpsavingstate, setAddgrpsavingstate] = useState('IDLE')// IDLE, SAVING, SUCCESS, FAILURE

    const [guestcats, setGuestcats] = useState([])
    const [showcat, setShowcat] = useState(false)
    const [addcatmodalguestcats, setAddcatmodalguestcats] = useState([])
    const [addcatsavingstate, setAddcatsavingstate] = useState('IDLE')// IDLE, SAVING, SUCCESS, FAILURE

    const [guestrelas, setGuestrelas] = useState([])
    const [showrelationship, setShowrelationship] = useState(false)
    const [addrelamodalguestrelas, setAddrelamodalguestrelas] = useState([])
    const [addrelasavingstate, setAddrelasavingstate] = useState('IDLE')// IDLE, SAVING, SUCCESS, FAILURE

    const [copymode, setCopymode] = useState(false)

    const [swapmade, setSwapmade] = useState(false) // if swap is made, switch showsave to true
    const [beforeswapdata, setBeforeswapdata] = useState({})
    const [showsave, setShowsave] = useState(false)

    const [deleteallstate, setDeleteallstate] = useState('NONE') // NONE, CONFIRM
    // delete all seated and unseated guests data

    useEffect(() => {
        if (copymode) {
            setTimeout(() => {
                setCopymode(false)
            }, [1500])
        }
    }, [copymode])

    const closeallpopups = () => {
        setShowexport(false)
        setShowimport(false)
        setShowsetting(false)
        setShowgrp(false)
        setShowcat(false)
        setShowrelationship(false)
        setShowhelp(false)
        setShowaddguest(false)
        setShowaddtable(false)
        setShowedittable(false)
        setShoweditsingleguest(false)
        setShoweditseatedguest(false)
        setShowtemplate(false)
        setShowqr(false)
    }

    function backupOriginaldata() {
        setBeforeswapdata({
            'guests': JSON.parse(JSON.stringify(guests)),
            'tableobjs': JSON.parse(JSON.stringify(tableobjs))
        })
    }


    const onCopy = (e) => {
        try {
            var test = function (regexp) {
                return regexp.test(window.navigator.userAgent);
            }

            if (test(/safari/i)) { // is safari
                copyToClipboard(e.target.value)
            }
            else {
                navigator.clipboard.writeText(e.target.value)
            }
            setCopymode(true)
        }
        catch (e) {
            console.log(e)
        }
    }

    const portalleftcss = { width: { 'WEB': 500, 'TABLET': 400, 'MOBILE': '100%' }[device], height: '100%', backgroundColor: 'white', top: 0, left: null, right: 0, transform: 'none' }

    useEffect(() => {

        props.hidetopbar(true)

        if (firsttime) {
            setLoad(true)
            try {
                const { id } = props.match.params

                axios({
                    method: 'POST',
                    url: READ_SCEDIT,
                    headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                    data: { id }
                }).then((item) => {
                    const { data, status } = item
                    const { etype, u_id, _id, urlhandler, tableobjs, guests, save_id, passcode, name, imgs, style, pages, onlineselectedpg, onlineselectedpgprops = {}, guestgrps, guestrelas, guestcats } = data.sc
                    if (status === 200) {
                        setScid(_id)
                        setUid(u_id)
                        setEtype(etype)
                        setPasscode(passcode)
                        setUrlhandler(urlhandler)

                        setTableobjs(tableobjs)
                        setGuests(guests)
                        setSave_id(save_id)
                        updateExcelresult(tableobjs, guests)
                        setName(name)
                        setImgs(imgs)
                        style ? setStyle(style) : setStyle({ fontFamily: '' })
                        setPages(pages)
                        setEditedsignal(false)
                        setOnlineselectedpg(onlineselectedpg)
                        setOnlineselectedpgprops(Object.assign(onlineselectedpgprops, {}))

                        setAddcatmodalguestcats(guestcats)
                        setGuestcats(guestcats)

                        setAddrelamodalguestrelas(guestrelas)
                        setGuestrelas(guestrelas)

                        setAddgrpmodalguestgrps(guestgrps)
                        setGuestgrps(guestgrps)
                        setLoad(false)

                    }
                }).catch((e) => {
                    props.history.push('/')
                })
            }
            catch (e) { props.history.push('/') }
            setFirsttime(false)
        }

        return () => { props.hidetopbar(false) }

    }, [])

    // useEffect(() => {
    //     if (showaddtable || showeditseatedguest || showedittable || showeditsingleguest) setMassmoveguests([])
    // }, [showaddtable || showeditseatedguest || showedittable || showeditsingleguest])

    useEffect(() => {
        if (onlineselectedsave) {
            Savefunc(guests, tableobjs, pages)
            setOnlineselectedsave(false)
            setTimeout(() => {
                const win = window.open(('/seatingchartlookup/' + urlhandler + (passcode && passcode.length > 0 ? `/passcode=${passcode}` : '')), "_blank")
                win.focus();
            }, 2200)

        }
    }, [onlineselectedsave])

    useEffect(() => {
        if (swapmade) { // swap being made
            // show save button if swap is being made
            setShowsave(true)
        }
    }, [swapmade])

    useEffect(() => {
        // trigger when user click deleteall and confirm
        if (deleteallstate === 'UPDATE') {
            axios({
                method: 'POST',
                url: DELETE_SCDATA,
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                data: { scid, urlhandler, save_id, passcode }
            })
                .then((item) => {
                    const { status } = item
                    if (status === 200) {
                        setDeleteallstate('DONE')
                        setGuests([])
                        setTableobjs([])
                    }
                })
                .catch((e) => { })
        }
    }, [deleteallstate])

    useEffect(() => {

    }, [])

    const modalsep = <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'center', width: '100%', alignItems: 'center', borderTop: '1px dashed black', margin: '45px 0px' }}>
    </div>

    const updateExcelresult = (tableobjs, guests) => {
        // UPDATE ON exceltableobjs
        // exceltableobjs = [
        //     ["Table", "Name","Relationship", "Category"],
        //     ["Table1","some name","mum's friend","first category, second category"]
        //     ["Table2","some name","dad's friend","first category, second category"]
        // ]
        let local_excelresult = []
        local_excelresult.push(['Table', 'Name', 'Relationship', 'Category'])
        for (let i = 0; i < tableobjs.length; i++) {
            const { max, guests, } = tableobjs[i] // id, name, guests, max
            if (guests && guests.length > 0) {
                for (let x = 0; x < guests.length; x++) {
                    const { id, name, cats, relas } = guests[x] // id, name, cats[array], relas[array]
                    local_excelresult.push([tableobjs[i].name, name, relas.toString(), cats.toString()])
                }
            }

        }
        for (let j = 0; j < guests.length; j++) {
            const { id, name, cats, relas } = guests[j]// id, name, cats[array], relas[array]
            local_excelresult.push(['Unassigned', name, relas.toString(), cats.toString()])
        }
        setExceltableobjs(local_excelresult)
        setEditedsignal(true)
    }

    const onDragEnd = (result) => {
        setOndrag(true)
        setMassmoveguests([])
        if (!result.destination) return;

        const { source, destination } = result
        var local_tables = tableobjs.slice()
        var local_guests = guests.slice()


        const draggableId = result.draggableId
        const currobj = draggableId.split('_')[0] // SEATEDGUEST, UNSEATEDGUEST
        const destination_droppableId = result.destination.droppableId
        const dest = destination_droppableId.split('_')[0] // UNSEATEDGUESTLIST, TABLE
        const source_droppableId = result.source.droppableId
        const src = source_droppableId.split('_')[0] // UNSEATEDGUESTLIST, TABLE
        function swapmade_and_backup() {
            if (!swapmade) {
                setSwapmade(true)
                backupOriginaldata()
            }
        }

        function getStats(source, destination) {
            const src_id = source.droppableId.replace(/^[^_]*_/, '');
            const src_index = source.index;
            const dest_id = destination.droppableId.replace(/^[^_]*_/, '');
            const dest_index = destination.index;
            return { src_id, src_index, dest_id, dest_index }

        }

        if (src === 'UNSEATEDGUESTLIST' && dest === 'UNSEATEDGUESTLIST' && currobj === 'UNSEATEDGUEST') { // UNSEATEDGUESTLIST <-> UNSEATEDGUESTLIST
            swapmade_and_backup()
            const { src_index, dest_index } = getStats(source, destination)
            const newUnseatedGuest = local_guests.map((guest) => { return guest });
            const [movedGuest] = newUnseatedGuest.splice(src_index, 1);
            newUnseatedGuest.splice(dest_index, 0, movedGuest);
            setGuests(newUnseatedGuest)
            updateExcelresult(local_tables, newUnseatedGuest)
        }
        else if (src === 'UNSEATEDGUESTLIST' && dest === 'TABLE' && currobj === 'UNSEATEDGUEST') { // UNSEATEDGUESTLIST -> TABLE
            swapmade_and_backup()
            const { src_index, dest_id, dest_index } = getStats(source, destination)
            const newUnseatedGuest = local_guests.map((guest) => { return guest });
            const newTableObjs = local_tables.map((table) => { return table });
            // bear
            const dest_table_index = newTableObjs.findIndex(t => t.id === dest_id);
            const [movedGuest] = newUnseatedGuest.splice(src_index, 1);
            newTableObjs[dest_table_index]['guests'].splice(dest_index, 0, movedGuest);
            setGuests(newUnseatedGuest)
            setTableobjs(newTableObjs)
            updateExcelresult(newTableObjs, newUnseatedGuest)
        }
        else if (src === 'TABLE' && dest === 'UNSEATEDGUESTLIST' && currobj === 'SEATEDGUEST') { // TABLE -> UNSEATEDGUESTLIST
            swapmade_and_backup()
            const { src_id, src_index, dest_index } = getStats(source, destination)
            const newUnseatedGuest = local_guests.map((guest) => { return guest });
            const newTableObjs = local_tables.map((table) => { return table });
            const src_table_index = newTableObjs.findIndex(t => t.id === src_id);
            const [movedGuest] = newTableObjs[src_table_index]['guests'].splice(src_index, 1);
            newUnseatedGuest.splice(dest_index, 0, movedGuest);
            setGuests(newUnseatedGuest)
            setTableobjs(newTableObjs)
            updateExcelresult(newTableObjs, newUnseatedGuest)
        }
        else { // TABLE <-> TABLE

            swapmade_and_backup()
            const { src_id, src_index, dest_id, dest_index } = getStats(source, destination)
            const newTableObjs = local_tables.map((table) => ({ ...table, guests: [...table.guests], }));            // Make a deep copy of the tables
            const src_table_index = newTableObjs.findIndex(t => t.id === src_id);
            const dest_table_index = newTableObjs.findIndex(t => t.id === dest_id);
            const [movedGuest] = newTableObjs[src_table_index]['guests'].splice(src_index, 1);            // Extract and insert guest safely
            newTableObjs[dest_table_index].guests.splice(dest_index, 0, movedGuest);
            setTableobjs(newTableObjs); // Update state with fresh object
            updateExcelresult(newTableObjs, local_guests)
        }
        setOndrag(false)
    }

    const portalmidcss = { width: { 'WEB': 500, 'TABLET': 450, 'MOBILE': '100%' }[device], height: { 'WEB': 500, 'TABLET': 400, 'MOBILE': '100%' }[device], backgroundColor: 'white', top: '50%', left: '50%', right: '', transform: 'translate(-50%,-50%)' }

    const NOT_SWAPPINGTABLE = swaptableindex === -1
    const NOT_PUTTINGGUESTS = massmoveguests.length === 0
    const NOT_SAVING = !showsave
    const NOT_DESIGNPAGE = mode !== 1
    const NOT_ONLINEPAGE = mode !== 2

     const importdata_modal = <Portalmodal
        portaltype={'commonportal'}
        open={NOT_DESIGNPAGE && NOT_ONLINEPAGE && NOT_SAVING && NOT_PUTTINGGUESTS && NOT_SWAPPINGTABLE && showimport}
        onClose={() => { setShowimport(false) }}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={portalmidcss}
        closestyle={{ right: 0 }}
        floatingclosecolor='#333333'
        title="Import Data"
    >
        <div className={device === 'MOBILE' ? 'SearchmodalM' : 'Searchmodal'} >
            <Importcontent
                urlhandler={urlhandler}
                sep={modalsep}
                onImport={(url) => {
                    axios({
                        method: 'POST',
                        url: REPLACE_SCDATA,
                        headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                        data: { url }
                    }).then((item) => {
                        const { status, data } = item
                        const { guestid_guestinfo_map } = data.item[0]


                        function obtain_all_guestids(guests, tableobjs) {
                            let ids = []
                            for (let i = 0; i < guests.length; i++) {
                                ids.push(guests[i].id)
                            }
                            for (let i = 0; i < tableobjs.length; i++) {
                                for (let j = 0; j < tableobjs[i].guests.length; j++) {
                                    ids.push(tableobjs[i].guests[j].id)
                                }
                            }
                            return ids
                        }
                        let allids = obtain_all_guestids(guests, tableobjs)
                        var names = []
                        if (status === 200) {
                            var arr = Object.keys(guestid_guestinfo_map)
                            for (let i = 0; i < arr.length; i++) {
                                const id = arr[i]
                                if (!allids.includes(id) && guestid_guestinfo_map[id]['1-name'].length> 0 && guestid_guestinfo_map[id]['8-rsvp'] === 'accept') {
                                    names.push({
                                        'id': id,
                                        'name': guestid_guestinfo_map[id]['1-name'],
                                        'relas': guestid_guestinfo_map[id]['6half-relationship'],
                                        'cats': guestid_guestinfo_map[id]['6-category'],
                                    })
                                }
                            }
                            setGuests([...guests, ...names])
                            
                            Savefunc([...guests, ...names], tableobjs, pages)

                        }
                    }).catch((e) => { 
                        console.log(e)
                    })

                }}
                ondrop={(row_obj) => {
                    try {
                        var name_index = -1
                        var table_index = -1
                        var relationship_index = -1
                        var category_index = -1
                        for (let x = 0; x < row_obj[0].data.length; x++) {
                            if (row_obj[0].data[x].toLowerCase() === 'name') {
                                name_index = x
                            }
                            if (row_obj[0].data[x].toLowerCase() === 'table') {
                                table_index = x
                            }
                            if (row_obj[0].data[x].toLowerCase() === 'relationship') {
                                relationship_index = x
                            }
                            if (row_obj[0].data[x].toLowerCase() === 'category') {
                                category_index = x
                            }
                        }

                        var local_guests = []
                        var local_tablemap = {}
                        var local_tablenames = []
                        for (let i = 1; i < row_obj.length; i++) {
                            const { data } = row_obj[i]
                            var name = data[name_index]
                            var table = data[table_index]
                            var relation = data[relationship_index]
                            var category = data[category_index]
                            if (table.length === 0) { // not seated
                                local_guests.push({ name: name, rela: relation, cat: category })
                            }

                            if (table.length > 0) { // seated
                                if (local_tablemap[table]) {
                                    local_tablemap[table]['seatnames'].push(name)
                                    local_tablemap[table]['relas'].push(relation)
                                    local_tablemap[table]['cats'].push(category)
                                }
                                else {
                                    local_tablemap[table] = { name: table, seatnames: [name], relas: [relation], cats: [category] }
                                    local_tablenames.push(table)
                                }
                            }

                        }

                        var local_tableobjs = []
                        for (let i = 0; i < local_tablenames.length; i++) {
                            const tname = local_tablenames[i]
                            local_tableobjs[i] = { name: tname, max: local_tablemap[tname].seatnames.length, seatnames: local_tablemap[tname].seatnames, relas: local_tablemap[tname].relas, cats: local_tablemap[tname].cats }
                        }

                        setGuests(local_guests)
                        setTableobjs(local_tableobjs)
                    }
                    catch (e) {
                        alert('Please make sure you upload the correct format.')
                    }
                }}
            />
        </div>
    </Portalmodal>

    const edittypenonselected = { height: 40, padding: '0px 10px', border: '1px solid var(--maindark)', backgroundColor: '#ffffff', marginRight: 5, borderRadius: 5 }
    const edittypeselected = { height: 40, padding: '0px 10px', border: '1px solid var(--mainpink)', backgroundColor: 'var(--mainpink)', marginRight: 5, borderRadius: 5, color: '#ffffff' }

    const setting_modal = <Portalmodal
        portaltype={'commonportal'}
        open={NOT_DESIGNPAGE && NOT_ONLINEPAGE && NOT_SAVING && NOT_PUTTINGGUESTS && NOT_SWAPPINGTABLE && showsetting}
        onClose={() => {
            setDeleteallstate('NONE')
            setShowsetting(false)
        }}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={portalmidcss}
        closestyle={{ right: 0 }}
        floatingclosecolor='#333333'
        title="Settings"
    >
        <div className={device === 'MOBILE' ? 'SearchmodalM' : 'Searchmodal'} >
            <div className="inviteedit_helproot">
                {partialtitle_dom('Mode', {})}
                {inputdescribe_dom('Simplify mode will show simple information, whereas detail mode will show the relationship and category of guests.', { marginBottom: 10, paddingLeft: 0, paddingRight: 0 })}
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <button style={edittype === 0 ? edittypeselected : edittypenonselected} onClick={() => setEdittype(0)}>Simplify</button>
                    <button style={edittype === 1 ? edittypeselected : edittypenonselected} onClick={() => setEdittype(1)}>Detail</button>
                </div>
            </div>
            <div className="inviteedit_helproot">
                {partialtitle_dom('Delete All Data', {})}
                {inputdescribe_dom('Delete all existing data.', { marginBottom: 10, paddingLeft: 0, paddingRight: 0 })}
                {{
                    'NONE': <button className='scedit_deleteroot' onClick={() => setDeleteallstate('CONFIRM')}>Delete All</button>,
                    'CONFIRM': <button className='scedit_deleteroot' onClick={() => setDeleteallstate('UPDATE')}>Confirm</button>,
                    'UPDATE': <div>Removing...</div>,
                    'DONE': <div>Done</div>
                }[deleteallstate]}
            </div>
            {/* <button className={'scedit_rightmode'} onClick={() => setEdittype(edittype === 0 ? 1 : 0)}>{edittype === 0 ? 'Simplify' : 'Detail'}</button> */}
        </div>
    </Portalmodal>

    const template_modal = <Portalmodal
        portaltype={'commonportal'}
        open={NOT_DESIGNPAGE && NOT_ONLINEPAGE && NOT_SAVING && NOT_PUTTINGGUESTS && NOT_SWAPPINGTABLE && showtemplate}
        onClose={() => { setShowtemplate(false) }}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={portalmidcss}
        closestyle={{ right: 0 }}
        floatingclosecolor='#333333'
        title="Template"
    >
        <div className={device === 'MOBILE' ? 'SearchmodalM' : 'Searchmodal'} >
            <div className="inviteedit_helproot">
                {partialtitle_dom('Sample Data', {})}
                {inputdescribe_dom('Replace your current seating chart with placeholder values.', { marginBottom: 10, paddingLeft: 0, paddingRight: 0 })}
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <button style={template === 0 ? edittypeselected : edittypenonselected} onClick={() => setTemplate(0)}>Dummy Value</button>
                </div>
                {template === 0 ? <button
                    className="scedit_modalbtn"
                    onClick={() => {
                        try {
                            axios({
                                method: 'POST',
                                url: UPDATE_TEMPLATE,
                                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                                data: { scid, urlhandler, save_id, passcode, template }
                            }).then((item) => {
                                const { message, new_saveid, templatejson } = item.data
                                if (message === 'SUCCESS') {
                                    setTableobjs(templatejson)
                                    setSave_id(new_saveid)
                                    setShowtemplate(false)

                                    let relas_set = new Set() // turn to arr [...relas_set]
                                    let cats_set = new Set()
                                    let grps_set = new Set()

                                    // check if got new relationships, group, category
                                    for (let i = 0; i < templatejson.length; i++) {

                                        for (let j = 0; j < templatejson[i].guests.length; j++) {

                                            const { relas, cats, grp } = templatejson[i].guests

                                            for (let k = 0; k < relas.length; k++) {
                                                relas_set.add(relas[k])
                                            }

                                            for (let k = 0; k < cats.length; k++) {
                                                cats_set.add(cats[k])
                                            }

                                            grps_set.add(grp)

                                        }

                                    }

                                    setAddrelamodalguestrelas((addrelamodalguestrelas) => {
                                        return [...new Set([...addrelamodalguestrelas, ...relas_set])]
                                    })

                                    setAddcatmodalguestcats((addcatmodalguestcats) => {
                                        return [...new Set([...addcatmodalguestcats, ...cats_set])]
                                    })

                                    setAddgrpmodalguestgrps((addgrpmodalguestgrps) => {
                                        return [...new Set([...addgrpmodalguestgrps, ...grps_set])]
                                    })

                                    setGuestcats((guestcats) => {
                                        return [...new Set([...guestcats, ...cats_set])]
                                    })

                                    setGuestrelas((guestrelas) => {
                                        return [...new Set([...guestrelas, ...relas_set])]
                                    })

                                    setGuestgrps((guestgrps) => {
                                        return [...new Set([...guestgrps, ...grps_set])]
                                    })

                                }
                                else {
                                    alert('expired')
                                }
                            }).catch((e) => {
                                console.log(e)
                            })
                        }
                        catch (e) { console.log(e) }
                    }}
                    style={{ marginBottom: 0, width: '100%', borderRadius: 5, display: 'flex' }}
                >
                    Update
                </button> : null}
            </div>
        </div>
    </Portalmodal>

    const edittable_modal = <Portalmodal
        animation="right_left"
        portaltype="commonportal"
        open={NOT_DESIGNPAGE && NOT_ONLINEPAGE && NOT_SAVING && NOT_PUTTINGGUESTS && NOT_SWAPPINGTABLE && showedittable}
        onClose={() => { setShowedittable(false) }}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={portalleftcss}
        closestyle={{ right: 0 }}
        floatingclosecolor='#333333'
    >
        <Edittablecontent
            DEVICE_MODALWT_MAP={{ 'WEB': 500, 'TABLET': 400, 'MOBILE': '100%' }[device]}
            device={device}
            data={edittabledata}
            update={(i, txt, max) => {
                try {
                    axios({
                        method: 'POST',
                        url: UPDATE_SINGLETABLE,
                        headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                        data: { scid, urlhandler, save_id, passcode, seatingstate: 'UNSEATED', tableindex: i, tablename: txt, tablequota: max }
                    })
                        .then((item) => {
                            const { message, new_saveid } = item.data
                            if (message === 'SUCCESS') {
                                var local_tablesobjs = tableobjs.slice()
                                var local_guests = guests.slice()
                                local_tablesobjs[i]['name'] = txt
                                local_tablesobjs[i]['max'] = max
                                setTableobjs(local_tablesobjs)
                                updateExcelresult(local_tablesobjs, local_guests)
                                setShowedittable(false)
                                setSave_id(new_saveid)
                            }
                            else {
                                alert('expired')
                            }
                        })
                        .catch((e) => {
                            console.log(e)
                        })
                }
                catch (e) { console.log(e) }
            }}
            rmv={(i) => {

                var local_tablesobjs = JSON.parse(JSON.stringify(tableobjs))


                if (local_tablesobjs[i]['guests'].length === 0) {
                    local_tablesobjs.splice(i, 1)
                    try {
                        axios({
                            method: 'POST',
                            url: RMV_SINGLETABLE,
                            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                            data: { scid, urlhandler, save_id, passcode, tableobjs: local_tablesobjs }
                        })
                            .then((item) => {
                                const { message, new_saveid } = item.data
                                if (message === 'SUCCESS') {
                                    setTableobjs(local_tablesobjs)
                                    setShowedittable(false)
                                    setSave_id(new_saveid)
                                }
                                else {
                                    alert('expired')
                                }
                            }).catch((e) => {
                                console.log(e)
                            })
                    }
                    catch (e) { console.log(e) }

                }
                else {
                    alert('Please remove all guests from this table before deletion.')
                }


            }}
        />
    </Portalmodal>

    const addtable_modal = <Portalmodal
        animation="right_left"
        portaltype="commonportal"
        open={NOT_DESIGNPAGE && NOT_ONLINEPAGE && NOT_SAVING && NOT_PUTTINGGUESTS && NOT_SWAPPINGTABLE && showaddtable}
        onClose={() => setShowaddtable(false)}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={portalleftcss}
        closestyle={{ right: 0 }}
        floatingclosecolor='#333333'
    >
        <Addtablecontent
            DEVICE_MODALWT_MAP={{ 'WEB': 500, 'TABLET': 400, 'MOBILE': '100%' }[device]}
            TABLE_MAX={TABLE_MAX}
            device={device}
            Modalsubtitle={Modalsubtitle}
            update={(addtableobjs) => {
                if ((addtableobjs.length + tableobjs.length) <= TABLE_MAX) {
                    for (let i = 0; i < addtableobjs.length; i++) {// checks
                        const { max } = addtableobjs[i]
                        if ((max < 1) || (max > MAX_GUEST_PER_TABLE)) {
                            alert('Max table cannot below 1 or more than 100.')
                            return
                        }
                    }
                    var final_tableobjs = [...tableobjs, ...addtableobjs]
                    setTableobjs(final_tableobjs)
                    updateExcelresult(final_tableobjs, guests.slice())
                    setShowaddtable(false)
                    Savefunc(guests, final_tableobjs, pages)
                }
                else {
                    alert('You have reach max number of tables.')
                }

            }}
        />
    </Portalmodal>

    const addguest_modal = <Portalmodal
        animation="right_left"
        portaltype="commonportal"
        open={NOT_DESIGNPAGE && NOT_ONLINEPAGE && NOT_SAVING && NOT_PUTTINGGUESTS && NOT_SWAPPINGTABLE && showaddguest}
        onClose={() => setShowaddguest(false)}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={portalleftcss}
        closestyle={{ right: 0 }}
        floatingclosecolor='#333333'
    >
        <Addguestcontent
            GUEST_MAX={GUEST_MAX}
            guestrelas={guestrelas}
            guestcats={guestcats}
            guestgrps={guestgrps}
            update={(all_new_added_guests) => {

                var curr_guests_len = guests.length || 0
                var curr_tableseatedguests_len = 0

                for (let j = 0; j < tableobjs.length; j++) {
                    if (tableobjs[j] && tableobjs[j].guests && tableobjs[j].guests.length > 0) {
                        curr_tableseatedguests_len += tableobjs[j].guests.length
                    }
                }

                var total_num_guests = curr_guests_len + curr_tableseatedguests_len + all_new_added_guests.length
                if (total_num_guests <= GUEST_MAX) {
                    var final_guests = [...guests, ...all_new_added_guests]
                    setGuests(final_guests)
                    updateExcelresult(tableobjs.slice(), final_guests)
                    setShowaddguest(false)
                    Savefunc(final_guests, tableobjs, pages)

                }
                else {
                    alert('You have reached the maximum number of guests.')
                }

            }}
        />
    </Portalmodal>

    const help_modal = <Portalmodal
        portaltype={'commonportal'}
        // NOT_DESIGNPAGE && NOT_ONLINEPAGE && 
        open={NOT_SAVING && NOT_PUTTINGGUESTS && NOT_SWAPPINGTABLE && showhelp}
        onClose={() => { setShowhelp(false) }}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={portalmidcss}
        closestyle={{ right: 0 }}
        floatingclosecolor='#333333'
        title="Getting Started"
    >
        <div className={device === 'MOBILE' ? 'SearchmodalM' : 'Searchmodal'} >
            <div className="inviteedit_helproot">

                <div className="inviteedit_helptitle" >Arrange Seat</div>
                <div className="ie_modaltext">
                    <div className='ie_num'>1</div>
                    <div> Upload .csv file or add the guests manually to the seating chart</div>
                </div>
                <div className="ie_modaltext">
                    <div className='ie_num'>2</div>
                    <div> Decide on the number of tables and seats</div>
                </div>
                <div className="ie_modaltext">
                    <div className='ie_num'>3</div>
                    <div>Start by assigning guest to their tables</div>
                </div>
                {EMPTYSPACE}
                <div className="inviteedit_helptitle" >Design</div>
                <div className="ie_modaltext">
                    <div className='ie_num'>1</div>
                    <div>Start by selecting the template by click the '+' sign at the bottom of Design page.</div>
                </div>
                <div className="ie_modaltext">
                    <div className='ie_num'>2</div>
                    <div>After selecting a template, you would have to choose the number of table your seating chart should have. You could have multiple seating charts, and the min table is 3 and max table is 12. </div>
                </div>
                <div className="ie_modaltext">
                    <div className='ie_num'>3</div>
                    <div>Each guest will automatically assigned to the seating chart.</div>
                </div>
                {EMPTYSPACE}
                <div className="inviteedit_helptitle" >Online</div>
                <div className="ie_modaltext">
                    <div className='ie_num'>1</div>
                    <div>If you have multiple chart with different design, you could choose the one that you want your online seating chart to look like.</div>
                </div>
                <div className="ie_modaltext">
                    <div className='ie_num'>2</div>
                    <div>Main text format referring to whether allow next line for the text on main text. </div>
                </div>
            </div>
        </div>
    </Portalmodal>

    const editsingleguest_modal = <Portalmodal // non seated guest
        animation="right_left"
        portaltype="commonportal"
        open={NOT_DESIGNPAGE && NOT_ONLINEPAGE && NOT_SAVING && NOT_PUTTINGGUESTS && NOT_SWAPPINGTABLE && showeditsingleguest}
        onClose={() => setShoweditsingleguest(false)}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={portalleftcss}
        closestyle={{ right: 0 }}
        floatingclosecolor='#333333'
    >
        <Editsingleguestcontent
            DEVICE_MODALWT_MAP={DEVICE_MODALWT_MAP}
            guestcats={guestcats}
            guestgrps={guestgrps}
            guestrelas={guestrelas}
            data={editsingleguestdata}
            device={device}
            update={(i, n, r, c, ti, g) => {

                let local_guest = guests.slice()
                local_guest[i]['name'] = n
                local_guest[i]['relas'] = r
                local_guest[i]['cats'] = c
                local_guest[i]['grp'] = g

                try {
                    axios({
                        method: 'POST',
                        url: UPDATE_SINGLEGUEST,
                        headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                        data: { scid, urlhandler, save_id, passcode, seatingstate: 'UNSEATED', singleguestobj: local_guest[i], guestindex: i }
                    }).then((item) => {
                        const { message, new_saveid } = item.data
                        if (message === 'SUCCESS') {
                            var local_guest = guests.slice()
                            var local_tableobjs = tableobjs.slice()
                            local_guest[i]['name'] = n
                            local_guest[i]['relas'] = r
                            local_guest[i]['cats'] = c
                            local_guest[i]['grp'] = g
                            setGuests(local_guest)
                            updateExcelresult(local_tableobjs, local_guest)
                            setSave_id(new_saveid)
                            setShoweditsingleguest(false)
                        }
                        else {
                            alert('expired')
                        }
                    }).catch((e) => {
                        console.log(e)
                    })
                }
                catch (e) { console.log(e) }
            }}
            rmv={(guestindex) => {
                var local_guests = JSON.parse(JSON.stringify(guests))
                local_guests.splice(guestindex, 1)
                try {
                    axios({
                        method: 'POST',
                        url: RMV_SINGLEGUEST,
                        headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                        data: { scid, urlhandler, save_id, passcode, guestindex, seatingstate: 'UNSEATED', guests: local_guests }
                    }).then((item) => {
                        const { message, new_saveid } = item.data
                        if (message === 'SUCCESS') {
                            setGuests(local_guests)
                            updateExcelresult(tableobjs, local_guests)
                            setSave_id(new_saveid)
                            setShoweditsingleguest(false)
                        }
                        else {
                            alert('expired')
                        }
                    }).catch((e) => {
                        console.log(e)
                    })
                }
                catch (e) { console.log(e) }


                // var local_guest = guests.slice()
                // local_guest.splice(i, 1)
                // setGuests(local_guest)
                // setEditsingleguestdata([])
                // setShoweditsingleguest(false)
            }}
        />
    </Portalmodal>

    const editseatedsingleguest_modal = <Portalmodal // seated guest
        animation="right_left"
        portaltype="commonportal"
        open={NOT_DESIGNPAGE && NOT_ONLINEPAGE && NOT_SAVING && NOT_PUTTINGGUESTS && NOT_SWAPPINGTABLE && showeditseatedguest}
        onClose={() => setShoweditseatedguest(false)}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={portalleftcss}
        closestyle={{ right: 0 }}
        floatingclosecolor='#333333'
    >
        <Editsingleguestcontent
            DEVICE_MODALWT_MAP={DEVICE_MODALWT_MAP}
            guestcats={guestcats}
            guestgrps={guestgrps}
            guestrelas={guestrelas}
            data={editseatedguestdata}
            device={device}
            update={(i, n, r, c, ti, g) => {

                let local_tableobjs = tableobjs.slice()
                local_tableobjs[ti]['guests'][i]['name'] = n
                local_tableobjs[ti]['guests'][i]['relas'] = r.slice()
                local_tableobjs[ti]['guests'][i]['cats'] = c.slice()
                local_tableobjs[ti]['guests'][i]['grp'] = g
                let singletableobj = local_tableobjs[ti]

                try {
                    axios({
                        method: 'POST',
                        url: UPDATE_SINGLEGUEST,
                        headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                        data: {
                            scid, urlhandler, save_id, passcode, seatingstate: 'SEATED',
                            singletableobj, tableindex: ti, tableguestindex: i,
                        }
                    }).then((item) => {
                        const { message, new_saveid } = item.data
                        if (message === 'SUCCESS') {
                            setTableobjs((tableobjs) => {
                                var local_tableobjs = tableobjs.slice()
                                local_tableobjs[ti]['guests'][i]['name'] = n
                                local_tableobjs[ti]['guests'][i]['relas'] = r.slice()
                                local_tableobjs[ti]['guests'][i]['cats'] = c.slice()
                                local_tableobjs[ti]['guests'][i]['grp'] = g
                                updateExcelresult(local_tableobjs, guests.slice())
                                return local_tableobjs
                            })
                            setSave_id(new_saveid)
                            setShoweditseatedguest(false)
                            setEditseatedguestdata({})
                        }
                        else {
                            alert('expired')
                        }
                    }).catch((e) => {
                        console.log(e)
                    })
                }
                catch (e) { console.log(e) }

            }}
            rmv={(gi, ti) => { // guestindex and tableindex
                var local_tableobjs = JSON.parse(JSON.stringify(tableobjs))
                local_tableobjs[ti]['guests'].splice(gi, 1)
                try {
                    axios({
                        method: 'POST',
                        url: RMV_SINGLEGUEST,
                        headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                        data: { scid, urlhandler, save_id, passcode, singletableobj: local_tableobjs[ti], tableindex: ti, seatingstate: 'SEATED' }
                    })
                        .then((item) => {
                            const { message, new_saveid } = item.data
                            if (message === 'SUCCESS') {
                                setTableobjs(local_tableobjs)
                                updateExcelresult(local_tableobjs, guests)
                                setSave_id(new_saveid)
                                setShoweditseatedguest(false)
                            }
                            else {
                                alert('expired')
                            }
                        })
                        .catch((e) => {
                            console.log(e)
                        })
                }
                catch (e) { console.log(e) }

            }}
        />
    </Portalmodal>

    // category
    const addcat_modal = <Portalmodal
        animation="right_left"
        portaltype="commonportal"
        open={NOT_DESIGNPAGE && NOT_ONLINEPAGE && NOT_SAVING && NOT_PUTTINGGUESTS && NOT_SWAPPINGTABLE && showcat}
        onClose={() => { setShowcat(false) }}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={portalleftcss}
        closestyle={{ right: 0 }}
        floatingclosecolor='#333333'
    >
        <Addcatcontent
            from="Searchchartedit"
            addcatmodalguestcats={addcatmodalguestcats}
            addcatsavingstate={addcatsavingstate}
            close={() => {
                if (addcatsavingstate === 'IDLE' || addcatsavingstate === 'FAILURE' || addcatsavingstate === 'SUCCESS') {
                    setShowcat(!showcat);
                    setAddcatsavingstate('IDLE');
                }
            }}
            save={(new_guestcats) => {
                if (addcatsavingstate === 'IDLE') {

                    setAddcatsavingstate('SAVING')

                    var newly_removed = []
                    for (let j = 0; j < guestcats.length; j++) {
                        if (!new_guestcats.includes(guestcats[j])) { // if cat not in old_cat means this is newly added
                            newly_removed.push(guestcats[j])
                        }
                    }

                    // UPDATE ON tableobjs
                    let new_tableobjs = tableobjs.slice()
                    for (let i = 0; i < new_tableobjs.length; i++) {
                        const { guests } = new_tableobjs[i]
                        for (let j = 0; j < guests.length; j++) {
                            for (let k = 0; k < newly_removed.length; k++) {
                                if (new_tableobjs[i]['guests'][j]['cats'].includes(newly_removed[k])) {
                                    const index = new_tableobjs[i]['guests'][j]['cats'].indexOf(newly_removed[k])
                                    new_tableobjs[i]['guests'][j]['cats'].splice(index, 1)
                                }
                            }
                        }
                    }

                    // UPDATE ON guests
                    let new_guests = guests.slice()
                    for (let j = 0; j < new_guests.length; j++) {
                        for (let k = 0; k < newly_removed.length; k++) {
                            if (new_guests[j]['cats'].includes(newly_removed[k])) {
                                const index = new_guests[j]['cats'].indexOf(newly_removed[k])
                                new_guests[j]['cats'].splice(index, 1)
                            }
                        }
                    }

                    let options = {
                        method: 'POST',
                        url: UPDATE_SCEDITCATEGORY,
                        headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                        data: { scid, urlhandler, save_id, passcode, new_guestcats, new_tableobjs, new_guests }
                    }
                    axios(options)
                        .then((result) => {
                            const { status, data } = result
                            if (status === 200) {
                                updateExcelresult(new_tableobjs, new_guests)
                                setSave_id(data.new_saveid)
                                setTableobjs(new_tableobjs)
                                setGuests(new_guests)
                                setGuestcats(new_guestcats)
                                setAddcatmodalguestcats(new_guestcats)
                                setAddcatsavingstate('SUCCESS')
                            }
                        })
                        .catch((e) => {
                            setAddcatsavingstate('FAILURE')
                        })
                }
            }}
        />
    </Portalmodal>

    // group
    const addgrp_modal = <Portalmodal
        animation="right_left"
        portaltype="commonportal"
        open={NOT_DESIGNPAGE && NOT_ONLINEPAGE && NOT_SAVING && NOT_PUTTINGGUESTS && NOT_SWAPPINGTABLE && showgrp}
        onClose={() => { setShowgrp(false) }}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={portalleftcss}
        closestyle={{ right: 0 }}
        floatingclosecolor='#333333'
    >
        <Addgrpcontent
            from="Searchchartedit"
            addgrpmodalguestgrps={addgrpmodalguestgrps}
            addgrpsavingstate={addgrpsavingstate}
            close={() => {
                if (addgrpsavingstate === 'IDLE' || addgrpsavingstate === 'FAILURE' || addgrpsavingstate === 'SUCCESS') {
                    setShowgrp(!showgrp);
                    setAddgrpsavingstate('IDLE');
                }
            }}
            save={(new_guestgrps) => {
                if (addgrpsavingstate === 'IDLE') {
                    setAddgrpsavingstate('SAVING')

                    var newly_removed = []
                    for (let j = 0; j < guestgrps.length; j++) {
                        if (!new_guestgrps.includes(guestgrps[j])) { // if cat not in old_cat means this is newly added
                            newly_removed.push(guestgrps[j])
                        }
                    }

                    // UPDATE ON tableobjs
                    let new_tableobjs = tableobjs.slice()
                    for (let i = 0; i < new_tableobjs.length; i++) {
                        const { guests } = new_tableobjs[i]
                        for (let j = 0; j < guests.length; j++) {
                            for (let k = 0; k < newly_removed.length; k++) {
                                if (new_tableobjs[i]['guests'][j]['grp'] === newly_removed[k]) {
                                    new_tableobjs[i]['guests'][j]['grp'] = ''
                                    break
                                }
                            }
                        }
                    }

                    // UPDATE ON guests
                    let new_guests = guests.slice()
                    for (let j = 0; j < new_guests.length; j++) {
                        for (let k = 0; k < newly_removed.length; k++) {
                            if (new_guests[j]['grp'] === newly_removed[k]) {
                                new_guests[j]['grp'] = ''
                                break
                            }
                        }
                    }

                    let options = {
                        method: 'POST',
                        url: UPDATE_SCEDITGROUP,
                        headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                        data: { scid, urlhandler, save_id, passcode, new_guestgrps, new_tableobjs, new_guests }
                    }
                    axios(options).then((result) => {
                        const { status, data } = result
                        if (status === 200) {
                            updateExcelresult(new_tableobjs, new_guests)
                            setSave_id(data.new_saveid)
                            setTableobjs(new_tableobjs)
                            setGuests(new_guests)
                            setGuestgrps(new_guestgrps.slice())
                            setAddgrpmodalguestgrps(new_guestgrps.slice())
                            setAddgrpsavingstate('SUCCESS')
                        }
                    }).catch((e) => {
                        setAddgrpsavingstate('FAILURE')
                    })
                }
            }}
        />
    </Portalmodal>

    // relationship
    const addrela_modal = <Portalmodal
        animation="right_left"
        portaltype="commonportal"
        open={NOT_DESIGNPAGE && NOT_ONLINEPAGE && NOT_SAVING && NOT_PUTTINGGUESTS && NOT_SWAPPINGTABLE && showrelationship}
        onClose={() => { setShowrelationship(false) }}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={portalleftcss}
        closestyle={{ right: 0 }}
        floatingclosecolor='#333333'
    >
        <Addrelacontent
            from="Searchchartedit"
            addrelamodalguestrelas={addrelamodalguestrelas}
            addrelasavingstate={addrelasavingstate}
            close={() => {
                if (addrelasavingstate === 'IDLE' || addrelasavingstate === 'FAILURE' || addrelasavingstate === 'SUCCESS') {
                    setShowrelationship(!showrelationship);
                    setAddrelasavingstate('IDLE');
                }
            }}
            save={(new_guestrelas) => {
                if (addrelasavingstate === 'IDLE') {
                    setAddrelasavingstate('SAVING')

                    var newly_removed = []
                    for (let j = 0; j < guestrelas.length; j++) {
                        const old_guestrelas = guestrelas[j]
                        if (!new_guestrelas.includes(old_guestrelas)) { // if cat not in old_cat means this is newly added
                            newly_removed.push(old_guestrelas)
                        }
                    }

                    // UPDATE ON tableobjs
                    let new_tableobjs = tableobjs.slice()
                    for (let i = 0; i < new_tableobjs.length; i++) {
                        const { guests } = new_tableobjs[i]
                        for (let j = 0; j < guests.length; j++) {
                            for (let k = 0; k < newly_removed.length; k++) {
                                if (new_tableobjs[i]['guests'][j]['relas'].includes(newly_removed[k])) {
                                    const index = new_tableobjs[i]['guests'][j]['relas'].indexOf(newly_removed[k])
                                    new_tableobjs[i]['guests'][j]['relas'].splice(index, 1)
                                }
                            }
                        }
                    }

                    // UPDATE ON guests
                    let new_guests = guests.slice()
                    for (let j = 0; j < new_guests.length; j++) {
                        for (let k = 0; k < newly_removed.length; k++) {
                            if (new_guests[j]['relas'].includes(newly_removed[k])) {
                                const index = new_guests[j]['relas'].indexOf(newly_removed[k])
                                new_guests[j]['relas'].splice(index, 1)
                            }
                        }
                    }

                    let options = {
                        method: 'POST',
                        url: UPDATE_SCEDITRELATIONSHIP,
                        headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                        data: { scid, urlhandler, save_id, passcode, new_guestrelas, new_tableobjs, new_guests }
                    }
                    axios(options).then((result) => {
                        const { status, data } = result
                        if (status === 200) {
                            updateExcelresult(new_tableobjs, new_guests)
                            setSave_id(data.new_saveid)
                            setTableobjs(new_tableobjs)
                            setGuests(new_guests)
                            setGuestrelas(new_guestrelas)
                            setAddrelamodalguestrelas(new_guestrelas)
                            setAddrelasavingstate('SUCCESS')
                        }
                    }).catch((e) => {
                        setAddrelasavingstate('FAILURE')
                    })
                }
            }}
        />
    </Portalmodal>

    const copydom = copymode
        ? <div id='copy_dom' style={{ width: '100vw', position: 'absolute', placeContent: 'center', alignContent: 'center', left: 0, display: 'flex', bottom: 150, zIndex: 99999999999999 }}>
            <div style={{ display: 'flex', width: 200, height: 40, backgroundColor: 'var(--maindark)', color: '#ffffff', placeContent: 'center', alignContent: 'center', borderRadius: 5, position: 'fixed', alignItems: 'center' }}>Copied!</div>
        </div>
        : null

    const qr_modal = <Portalmodal
        portaltype={'commonportal'}
        open={NOT_DESIGNPAGE && NOT_SAVING && NOT_PUTTINGGUESTS && NOT_SWAPPINGTABLE && showqr}
        onClose={() => { setShowqr(false) }}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={portalmidcss}
        closestyle={{ right: 0 }}
        floatingdom={copydom}
        floatingclosecolor='#333333'
        title={'QR Code'}
    >
        <div className={device === 'MOBILE' ? 'SearchmodalM' : 'Searchmodal'} >
            <div className="inviteedit_helproot">
                <p className="ie_modaltext" style={{ marginBottom: 15 }}>Printable version QR code for your guest during wedding that will automatically direct them to your online seating chart.</p>
                <div className="Details_grp" style={{ display: 'flex', flexDirection: 'row' }}>
                    {input_dom(
                        'Seating Chart URL Handler',
                        '',
                        `${WEBSITE_URL}/seatingchartlookup/${urlhandler}/passcode=${passcode}`,
                        (e) => {
                        },
                        'urlhandler_id',
                        {},
                        true,
                        null,
                        {},
                        { marginLeft: 0, marginRight: 0, width: '100%', margin: 0, }
                    )}
                    <button
                        className="planning_editbtn"
                        style={{}}
                        onClick={onCopy}
                        value={`${WEBSITE_URL}/seatingchartlookup/${urlhandler}/passcode=${passcode}`}>
                        {iconwrapper(COPY_ICON, { borderRadius: 5, padding: 0, margin: 0, width: 20, height: 20, pointerEvents: 'none' })}
                    </button>
                </div>
                <div className="Details_grp" style={{ display: 'flex', flexDirection: 'row', placeContent: 'end' }}>
                    <Link id='qr_link' to="/tools/qr" target="_blank" style={{ visibility: 'hidden' }} />
                    <button
                        className='Ieditcomp_qr'
                        onClick={() => {
                            document.getElementById('qr_link').click()
                        }}
                    >
                        <div>QR App</div>
                        {iconwrapper(ENTER_ICON, { width: 24, height: 24, marginLeft: 5 })}
                    </button>
                </div>
            </div>
        </div>
    </Portalmodal>

    const exportdata_modal = <Portalmodal
        portaltype={'commonportal'}
        open={NOT_DESIGNPAGE && NOT_ONLINEPAGE && NOT_SAVING && NOT_PUTTINGGUESTS && NOT_SWAPPINGTABLE && showexport}
        onClose={() => { setShowexport(false) }}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={portalmidcss}
        closestyle={{ right: 0 }}
        floatingclosecolor='#333333'
        title="Export Data"
    >
        <div className={device === 'MOBILE' ? 'SearchmodalM' : 'Searchmodal'} >
            <div className="inviteedit_helproot">
                {partialtitle_dom('Download Guest List', {})}
                {inputdescribe_dom('Download your seat chart guest list.')}
                {((exceltableobjs && exceltableobjs.length > 0) || (guests && guests.length > 0)) && !ondrag && !showedittable && !showaddtable && !showaddguest && !showeditsingleguest && !showeditseatedguest
                    ? <CSVDownloader
                        className='scedit_csvdownloaderbtn'
                        style={{ width: '100%' }}
                        type={'link'}
                        data={exceltableobjs}
                        filename={`${STARTUP_NAME}_csv`}
                    >
                        <button
                            className="scedit_modalbtn"
                            style={{ marginBottom: 0, marginTop: 0, borderRadius: 5 }}
                            onClick={() => {
                                try {
                                    document.getElementsByClassName('scedit_csvdownloaderbtn').click()
                                }
                                catch (e) {

                                }
                            }}
                        >
                            Download
                        </button>
                    </CSVDownloader>
                    : null}

                {/* <Exportcontent
                    sep={modalsep}
                    csvdownload_div={// to make sure excel gt ready data || guest gt objs && not on drag and modal all close
                        ((exceltableobjs && exceltableobjs.length > 0) || (guests && guests.length > 0)) && !ondrag && !showedittable && !showaddtable && !showaddguest && !showeditsingleguest && !showeditseatedguest
                            ? <CSVDownloader data={exceltableobjs} filename={`${STARTUP_NAME}_csv`} style={{ width: '100%' }} type={'link'} >
                                <button className="scedit_modalbtn" >Download</button>
                            </CSVDownloader>
                            : null}
                    imgdownload_div={<button
                        className="scedit_modalbtn"
                        style={{ marginBottom: 44 }}
                        onClick={() => {
                            // var elem = document.getElementById("scedit_righttableroot");
                            // alert(elem.scrollHeight)
                            // alert(elem.clientHeight)
                            // const a1_v = { height: 9933, width: 7016 } // single row 4 cards, 
                            // const a1_h = { heigh: 7016, width: 9933 } // 
                            // const a4 = {height: 3508, width: 2480}   
                            // domtoimage.toBlob(document.getElementById('scedit_righttableroot'), a1_h).then(function (blob) {
                            //     saveAs(blob, 'my-node.png');
                            // });
                        }}>Download</button>} */}
                {/* /> */}

            </div>
        </div>
    </Portalmodal>



    // const exportdata_modal = <Jfmodal // EXPORT DATA MODAL
    //     show={showexport}
    //     title={'Export Guest List'}
    //     onHide={() => setShowexport(false)}
    //     device={device}
    //     content={<Exportcontent
    //         sep={modalsep}
    //         csvdownload_div={// to make sure excel gt ready data || guest gt objs && not on drag and modal all close
    //             ((exceltableobjs && exceltableobjs.length > 0) || (guests && guests.length > 0)) && !ondrag && !showedittable && !showaddtable && !showaddguest && !showeditsingleguest && !showeditseatedguest
    //                 ? <CSVDownloader data={exceltableobjs} filename={`${STARTUP_NAME}_csv`} style={{ width: '100%' }} type={'link'} >
    //                     <button className="scedit_modalbtn" >Download</button>
    //                 </CSVDownloader>
    //                 : null}
    //         imgdownload_div={<button
    //             className="scedit_modalbtn"
    //             style={{ marginBottom: 44 }}
    //             onClick={() => {
    //                 // var elem = document.getElementById("scedit_righttableroot");
    //                 // alert(elem.scrollHeight)
    //                 // alert(elem.clientHeight)
    //                 // const a1_v = { height: 9933, width: 7016 } // single row 4 cards, 
    //                 // const a1_h = { heigh: 7016, width: 9933 } // 
    //                 // const a4 = {height: 3508, width: 2480}   
    //                 // domtoimage.toBlob(document.getElementById('scedit_righttableroot'), a1_h).then(function (blob) {
    //                 //     saveAs(blob, 'my-node.png');
    //                 // });
    //             }}>Download</button>}
    //     />}
    // />


    const edittablefunc = (name, max, tableIndex) => {
        if (!swapmade) {
            setShowedittable(true)
            setEdittabledata([name, max, tableIndex])
        }
    }

    const swapfunc = (ti) => {
        if (window.confirm(tableobjs[swaptableindex].name + ' will swap with ' + tableobjs[ti].name)) {
            var local_tableobjs = JSON.parse(JSON.stringify(tableobjs))
            var temp = local_tableobjs[ti]
            local_tableobjs[ti] = local_tableobjs[swaptableindex]
            local_tableobjs[swaptableindex] = temp

            try {
                axios({
                    method: 'POST',
                    url: UPDATE_SWAP,
                    headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                    data: { scid, urlhandler, save_id, passcode, guests, tableobjs: local_tableobjs }
                }).then((item) => {
                    const { message, new_saveid } = item.data
                    if (message === 'SUCCESS') {
                        setTableobjs(local_tableobjs)
                        setSwaptableindex(-1)
                        setSave_id(new_saveid)
                        setShoweditseatedguest(false)
                    }
                    else {
                        alert('expired')
                    }
                }).catch((e) => {
                    console.log(e)
                })
            }
            catch (e) { console.log(e) }


        }
    }

    const Savefunc = (guests, tableobjs, pages) => {

        const expired = () => {
            setNoti('Session Expired')
            setTimeout(() => {
                props.history.push('/')
            }, 1500)
        }
        setEditedsignal(false)
        setNoti('Saving...')
        setTimeout(() => {
            try {
                axios({
                    method: 'POST',
                    url: UPDATE_SC,
                    headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
                    data: { tableobjs, guests, scid, urlhandler, save_id, passcode, name, imgs, style, pages, onlineselectedpg, onlineselectedpgprops }
                }).then((item) => {
                    const { message, new_saveid } = item.data
                    if (message === 'SUCCESS') {
                        setSave_id(new_saveid)
                        setNoti('Saved')
                        setTimeout(() => { setNoti('') }, 1000)
                    }
                    else expired()
                }).catch((e) => { expired() })
            }
            catch (e) { expired() }
        }, 800)
    }

    const shownameonly = (n) => <div>{n}</div>

    const showdetailguestinfo = (name, rela, cat, grp = '') => {
        // return <div className="scedit_modeoneroot" >
        //     <div className="scedit_modeonename">{name}</div>
        //     <div className="scedit_modeonerela">{'rel : ' + rela}</div>
        //     <div className="scedit_modeonecat">{'cat : ' + cat}</div>
        // </div>
        return <div className="scedit_detailguest" >

            <div className="scedit_detailguestname">{`${name}`}</div>

            <div className='scedit_detailguestgrproot'>
                <div className='scedit_detailguestlabel'>{`Group`}</div>
                {grp.length > 0 ? <div className='scedit_detailguestgrptxt'>{grp}</div> : null}
            </div>

            <div className='scedit_detailguestcatroot'>
                <div className='scedit_detailguestlabel'>{`Category`}</div>
                {cat && cat.length > 0
                    ? <div className='scedit_detailguestcat'>
                        {cat.map((item, index) => {
                            return <div key={item + index} className='scedit_detailguesttag' >{item}</div>
                        })}
                    </div>
                    : null}
            </div>

            <div className='scedit_detailguestrelaroot'>
                <div className='scedit_detailguestlabel'>{`Relationship(s)`}</div>
                {rela && rela.length > 0
                    ? <div className='scedit_detailguestrela'>
                        {rela.map((item, index) => {
                            return <div key={item + index} className='scedit_detailguesttag' >{item}</div>
                        })}
                    </div>
                    : null}
            </div>

        </div>
    }

    const LEFT = (
        <div className="scedit_leftroot">
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', minHeight: 50 }}>
                {massmoveguests.length > 0
                    ? <button
                        className={"scedit_iconput"}
                        onClick={() => {
                            var local_tableobjs = tableobjs.slice()
                            var local_guests = guests.slice()

                            // get the full guest object and store in guestobj map
                            let guestobjs = {}
                            Remove_guests_and_create_guestobj(massmoveguests, local_tableobjs, local_guests, guestobjs)

                            let massmoveguestsobjs = []
                            Translate_id_to_obj(massmoveguests, massmoveguestsobjs, guestobjs)

                            setTableobjs(local_tableobjs.slice())
                            setGuests([...massmoveguestsobjs.slice(), ...local_guests.slice()])
                            setMassmoveguests([])
                            setShowsave(true)
                        }}
                    >
                        PUT
                    </button>
                    : null}
            </div>
            <Droppable droppableId={'UNSEATEDGUESTLIST'} type="main" style={{ display: 'flex', placeContent: 'center', overflowX: 'hidden', position: 'relative', height: 'calc( 100vh - 113px )', minHeight: 'calc( 100vh - 113px )' }}>
                {(provided, snapshot) => (
                    <div {...provided.droppableProps} ref={provided.innerRef} style={getGuestliststyle(snapshot.isDraggingOver)}>
                        {guests && guests.map((guest, guestIndex) => {
                            const { id, name, relas, cats, grp } = guest
                            const guestclick = () => {
                                if (!swapmade) {
                                    setShoweditsingleguest(true)
                                    setEditsingleguestdata({ guest: guest, guestindex: guestIndex })
                                }
                            }
                            const massmoveclick = () => {
                                if (tableobjs.length > 0) {
                                    var temp = massmoveguests.slice()
                                    if (massmoveguests.includes(id)) {
                                        temp.splice(massmoveguests.indexOf(id), 1)
                                    }
                                    else temp.push(id)
                                    setMassmoveguests(temp)
                                    backupOriginaldata()
                                }
                            }
                            return <Draggable key={'UNSEATEDGUEST_' + guestIndex} draggableId={'UNSEATEDGUEST_' + guestIndex} index={guestIndex} type="main">
                                {(p, s) => (
                                    <div key={guestIndex + 'guest'} ref={p.innerRef} {...p.draggableProps} {...p.dragHandleProps} >
                                        <div className="scedit_guestrow"
                                            style={{
                                                ...(s.isDragging
                                                    ? { border: '1px solid var(--subgrey)', }
                                                    : { borderBottom:guestIndex !== guests.length - 1 ? '1px solid var(--subgrey)' : '', paddingBottom: guestIndex === guests.length - 1 ? 80 : 0 })
                                            }}
                                        >
                                            <div
                                                className={massmoveguests.includes(id) ? "scedit_selectedguestindex" : "scedit_guestindex"}
                                                onClick={massmoveclick}
                                            >
                                                {guestIndex + 1}
                                            </div>


                                            <div
                                                className={edittype === 0 ? "scedit_gstripright" : 'scedit_gstriprightdetail'}
                                                onClick={guestclick}
                                            >
                                                {edittype === 0
                                                    ? shownameonly(name)
                                                    : showdetailguestinfo(name, relas, cats, grp)}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Draggable>
                        })}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
            <div style={{ height: 80 }}></div>
            {/* <div style={{ display: 'flex', flexDirection: 'row', minHeight: 80, width: '100%' }}>
                <button className="scedit_addbtn" onClick={() => { setShowaddguest(true) }}>
                    <div className="scedit_plus">+</div>
                    {ADDNEWUSER_SMALL}
                </button>
            </div> */}
        </div>
    )

    const updatecorners = () => {
        const index = corners.indexOf(imgs[2])
        const final_index = index === corners.length - 1 ? 0 : index + 1
        const newbanner = corners[final_index]
        setImgs([imgs[0], imgs[1], newbanner])
    }

    const updateff = (e) => {
        setStyle({ fontFamily: e.target.value })
    }

    const device_fs_map = {
        'WEB': 50,
        'TABLET': 40,
        'MOBILE': '5vmin'
    }

    const put = (tableIndex) => {
        var local_tableobjs = tableobjs.slice()
        var local_guests = guests.slice()

        // remove guests from tables
        let guestobjs = {}
        Remove_guests_and_create_guestobj(massmoveguests, local_tableobjs, local_guests, guestobjs)

        // change ids in massmoveguests to obj
        let massmoveguestsobjs = []
        Translate_id_to_obj(massmoveguests, massmoveguestsobjs, guestobjs)


        // update table with all the new ids to be placed to the front        
        local_tableobjs[tableIndex]['guests'] = [...massmoveguestsobjs.slice(), ...local_tableobjs[tableIndex]['guests']]

        setGuests(local_guests.slice())
        setTableobjs(local_tableobjs.slice())
        setMassmoveguests([])
        setShowsave(true)
    }

    // {mode === 1 ? right_design_tools : null}
    const RIGHT = (
        <div className="scedit_right">
            <div className='scedit_topmenubar'>
                {/* <button className={'scedit_rightmode'} onClick={() => setEdittype(edittype === 0 ? 1 : 0)}>{edittype === 0 ? 'Simplify' : 'Detail'}</button> */}
                {/* <button className={'scedit_rightmode'} onClick={() => setShowsetting(true)}>Setting</button> */}
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <button className='scedit_qrbtn' style={{ backgroundColor: '#ffffff', height: 40, width: 40, alignItems: 'center', placeContent: 'center', marginLeft: 10 }} onClick={() => setShowsetting(true)}>
                        {iconwrapper(SETTING_ICON, { width: 24, height: 24, })}
                    </button>
                    <button className='scedit_qrbtn' style={{ backgroundColor: '#ffffff', height: 40, width: 40, alignItems: 'center', placeContent: 'center' }} onClick={() => { if (!swapmade) { setShowtemplate(true) } }}>
                        {iconwrapper(ITINERARYTEMPLATE_ICON, { width: 24, height: 24, })}
                    </button>

                    <div style={{ height: 40, width: 1, backgroundColor: 'var(--subgrey)', marginRight: 5 }} />

                    <button className='scedit_qrbtn' style={{ backgroundColor: '#ffffff', height: 40, width: 40, alignItems: 'center', placeContent: 'center' }} onClick={() => { if (!swapmade) { setShowcat(true) } }}>
                        {iconwrapper(CAT_ICON, { width: 24, height: 24, })}
                    </button>
                    <button className='scedit_qrbtn' style={{ backgroundColor: '#ffffff', height: 40, width: 40, alignItems: 'center', placeContent: 'center' }} onClick={() => { if (!swapmade) { setShowgrp(true) } }}>
                        {iconwrapper(GRP_ICON, { width: 24, height: 24, })}
                    </button>
                    <button className='scedit_qrbtn' style={{ backgroundColor: '#ffffff', height: 40, width: 40, alignItems: 'center', placeContent: 'center' }} onClick={() => { if (!swapmade) { setShowrelationship(true) } }}>
                        {iconwrapper(RELATIONSHIP_ICON, { width: 24, height: 24, })}
                    </button>
                </div>

                <div className='scedit_btnrow'>
                    <div className={'scedit_righttext'}>
                        <div>{tableobjs.length}</div>
                        <div>{'Tables'}</div>
                    </div>
                    <div className={'scedit_righttext'}>
                        <div>{guests.length}</div>
                        <div>{'Unseated'}</div>
                    </div>
                    <div className={'scedit_righttext'}>
                        <div>{tableobjs.reduce((tot, arr) => (tot + (arr && arr.guests ? arr.guests.length : 0)), 0)}</div>
                        <div>{'Seated'}</div>
                    </div>
                    <div className={'scedit_righttext'} style={{ marginRight: 10 }}> {/* return the sum with previous value */}
                        <div>{guests.length + tableobjs.reduce((tot, arr) => (tot + (arr && arr.guests ? arr.guests.length : 0)), 0)}</div>
                        <div>{'Guests'}</div>
                    </div>
                    {/* <button className="scedit_preview" onClick={() => {
                        const win = window.open(('/seatingchartlookup/' + urlhandler + (passcode && passcode.length > 0 ? `/passcode=${passcode}` : '')), "_blank")
                        win.focus();
                    }}>
                        {LOOKUPUNSTYLE_ICON} Preview
                    </button> */}
                </div>
            </div>
            {!swapmade && !showsave && massmoveguests.length === 0
                ? <div className="scedit_btncol" >
                    <button className='scedit_portalbtn scedit_btntop' onClick={() => setShowaddtable(true)}>
                        <div className='scedit_plus'>+</div>
                        <div style={{ width: 32, height: 31, paddingLeft: 2, fill: 'var(--mainpink)', display: 'flex', placeContent: 'center', alignItems: 'center' }}>{tablesvg}</div>
                    </button>
                    <button className='scedit_portalbtn scedit_btnbtm' onClick={() => { setShowaddguest(true) }}>
                        <div className="scedit_plus">+</div>
                        {ADDNEWUSER_SMALL}
                    </button>
                </div>
                : null}





            {/* DRAGGABLE SEATED GUESTS */}
            <div className='scedit_righttableroot' >
                {tableobjs && Object.keys(tableobjs) && tableobjs.map(({ id, name, guests = [], max, relas, cats }, tableIndex) => {

                    const tableId = id
                    const tableKey = 'table_' + tableIndex

                    var border_css = (guests.length - max === 0) ? '2px solid var(--donegreen)' : guests.length > max ? '2px solid red' : '1px solid var(--subgrey)' // 1px solid #707070

                    const tableproperties_div = <div style={{
                        padding: 5, width: '100%', borderBottom: '1px solid var(--subgrey)',
                        // marginBottom: 10,
                        display: 'flex', justifyContent: 'space-between'
                    }} onClick={() => edittablefunc(name, max, tableIndex)}>
                        <div>{name}</div>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <div key={max}>{guests.length + ' / ' + max}</div>
                            {guests.length - max === 0
                                ? iconwrapper(TICK_ICON, tableiconcss)
                                : guests.length > max
                                    ? iconwrapper(CROSS_ICON, tablecrossiconcss)
                                    : null}
                        </div>
                    </div>

                    if (swaptableindex > -1) {
                        return <div className="scedit_table" key={tableKey} style={{ border: border_css }}>
                            {swaptableindex !== tableIndex
                                ? <div
                                    style={{ position: 'absolute', top: 0, left: 0, height: '100%', width: '100%', borderRadius: 5, backgroundColor: '#00000066', display: 'flex', alignItems: 'center', placeContent: 'center', color: 'white', cursor: 'pointer', fontSize: 16, }}
                                    onMouseMove={() => { setSelectedswapindex(tableIndex) }}
                                    onClick={() => swapfunc(tableIndex)} >
                                    {selectedswapindex === tableIndex ? 'Click To Swap' : ''}
                                </div>
                                : null}
                            {tableproperties_div}
                            <Droppable droppableId={`TABLE_${tableId}`} type="main" style={{ height: '100%', marginBottom: 80 }} >
                                {(provided, snapshot1) => (
                                    <div className="scedit_droppable" {...provided.droppableProps} ref={provided.innerRef} style={getTableStyle(snapshot1.isDraggingOver)}>
                                        {guests && guests.filter(guest => guest).map((guest, guestindex) => {

                                            const { id, name, relas, cats, grp } = guest
                                            const guestId = id
                                            return <Draggable className="scedit_droppable" key={tableId + '_' + guestId} draggableId={`SEATEDGUEST_${guestId}`} index={guestindex} type="main">
                                                {(provided, snapshot) => (
                                                    <div style={{ width: '100%' }} key={guestindex + 'guest'} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
                                                        <div className="scedit_singleseatedroot" style={snapshot.isDragging ? { border: '1px solid var(--subgrey)' } : { borderBottom: '1px solid var(--subgrey)' }}>
                                                            <div className="scedit_singleseatednum">{guestindex + 1}</div>
                                                            <div className={edittype === 0 ? "scedit_gstripright" : 'scedit_gstriprightdetail'}>
                                                                {edittype === 0
                                                                    ? shownameonly(name)
                                                                    : showdetailguestinfo(name, relas, cats, grp)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </Draggable>
                                        })}
                                        {provided.placeholder}
                                    </div>)}
                            </Droppable>
                            <div
                                // className={tableIndex !== swaptableindex ? "scedit_iconhide" : "scedit_icon"}
                                className={"scedit_icon"}
                                onClick={() => {
                                    tableIndex === swaptableindex
                                        ? setSwaptableindex(-1)
                                        : setSwaptableindex(tableIndex)


                                    if (tableIndex === swaptableindex) {
                                        closeallpopups()

                                    }

                                }}>
                                {swaptableindex === tableIndex ? 'Cancel' : 'Swap'}
                            </div>
                        </div>
                    }
                    else
                        return <div className="scedit_table" key={tableKey} style={{ border: border_css }}>
                            {tableproperties_div}
                            <Droppable droppableId={`TABLE_${tableId}`} type="main" >
                                {(provided, snapshot1) => (
                                    <div className="scedit_droppable" {...provided.droppableProps} ref={provided.innerRef} style={{ ...getTableStyle(snapshot1.isDraggingOver), height: '100%', width: '100%' }} >
                                        {guests && guests.map((guest, guestindex) => {

                                            if (!guest) return null; // ⚠️ This skips index `i`
                                            const { id, name, relas, cats, grp } = guest
                                            const guestId = id
                                            const seatedguestclick = () => {
                                                if (!swapmade) {
                                                    setShoweditseatedguest(true)
                                                    setEditseatedguestdata({ 'guest': guest, 'guestindex': guestindex, 'tableindex': tableIndex })
                                                }
                                            }
                                            const massmoveclick = () => {

                                                var new_massmoveguests = massmoveguests.slice()

                                                if (massmoveguests.includes(id)) { // remove of single guest from massmoveguests
                                                    new_massmoveguests.splice(massmoveguests.indexOf(id), 1)
                                                    if (new_massmoveguests.length === 0) { // if massmoveguests left with none, close of massmoving state
                                                        closeallpopups()
                                                    }
                                                }
                                                else {
                                                    new_massmoveguests.push(id)
                                                }
                                                setMassmoveguests(new_massmoveguests)
                                                backupOriginaldata()

                                            }
                                            return <Draggable key={tableId + '_' + guestId} draggableId={`SEATEDGUEST_${guestId}`} index={guestindex} type="main">
                                                {(provided, snapshot) => {
                                                    return <div className="scedit_droppable" key={guestindex + 'seatname'} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
                                                        <div className="scedit_singleseatedroot" style={snapshot.isDragging ? { border: '1px solid var(--subgrey)' } : { borderBottom: '1px solid var(--subgrey)' }}>
                                                            <div
                                                                className={massmoveguests.includes(id) ? "scedit_singleselectedseatednum" : "scedit_singleseatednum"}
                                                                onClick={massmoveclick}
                                                            >
                                                                {guestindex + 1}
                                                            </div>
                                                            <div
                                                                className={edittype === 0 ? "scedit_gstripright" : 'scedit_gstriprightdetail'}
                                                                onClick={seatedguestclick}
                                                            >
                                                                {edittype === 0
                                                                    ? shownameonly(name)
                                                                    : showdetailguestinfo(name, relas, cats, grp)}
                                                            </div>

                                                        </div>
                                                    </div>
                                                }}
                                            </Draggable>
                                        })}
                                        {provided.placeholder}
                                    </div>)}
                            </Droppable>
                            <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'space-between' }}>
                                {massmoveguests.length > 0
                                    ? <button className={"scedit_iconput"} onClick={() => { put(tableIndex) }}>PUT</button>
                                    : <div />}
                                {tableobjs.length > 1 && !swapmade && !showsave
                                    ? <div
                                        key={'before'}
                                        className={"scedit_icon"}
                                        onClick={() => {
                                            setSwaptableindex(tableIndex);
                                            setMassmoveguests([]);
                                        }}
                                    >
                                        Swap Table
                                    </div>
                                    : null}
                            </div>
                        </div>
                })}
            </div>
        </div >
    )

    // useEffect(() => {
    //     if (!swapmade && !showsave) {
    //         setBeforeswapdata({})
    //     }
    // }, [mode, swapmade, showsave])

    const resetswapdata = () => {
        if (showsave && swapmade) {
            const { guests, tableobjs } = beforeswapdata
            setShowsave(false)
            setSwapmade(false)
            setGuests(JSON.parse(JSON.stringify(guests)))
            setTableobjs(JSON.parse(JSON.stringify(tableobjs)))
        }
    }

    const guestoreditorbtn = <div className='scedit_selectorrow'>
        <Togglebutton
            funcs={[
                () => {
                    if (showsave) { return }
                    setMode(mode === 0 ? 1 : 0)
                    resetswapdata()
                },
                () => {
                    if (showsave) { return }
                    setMode(mode === 1 ? 0 : 1)
                    resetswapdata()
                },
                () => {
                    if (showsave) { return }
                    setMode(mode === 2 ? 0 : 2)
                    resetswapdata()
                }
            ]}
            txts={['Arrange Seat', 'Design', 'Online']}
            btnselected={mode}
            disabled={!NOT_SWAPPINGTABLE || !NOT_SAVING || !NOT_PUTTINGGUESTS} // if its swapping table or saving or puttingguests buttons should be disabled
        />
        <div
            className='scedit_qnmark'
            onClick={() => {
                setShowhelp(true)
            }}>
            ?
        </div>
    </div>

    const savebtn = editedsignal
        ? <button className="scedit_savingbtn" style={{ marginRight: 0 }} onClick={() => Savefunc(guests, tableobjs, pages)}>Save</button>
        : <button className="scedit_savebtn" style={{ marginRight: 0 }} onClick={() => Savefunc(guests, tableobjs, pages)}>Save</button>
    const exportbtn = <button className="scedit_exportbtn" onClick={() => { if (!swapmade) { setShowexport(true) } }}>Export Data</button>
    const importbtn = <button className="scedit_importbtn" onClick={() => { if (!swapmade) { setShowimport(true) } }}>Import Data</button>
    // const qrbtn = <button className="scedit_qrbtn" style={{ marginRight: 0 }} onClick={() => setShowqr(true)}>{iconwrapper(PLANNING_QR_ICON, { width: 24, height: 24 })}</button>
    const backicon = <button className="planning_backicon" style={{ left: 10, position: 'absolute' }} onClick={() => { setReturnhome(true) }}>{ARROWLEFT_ICON}</button>
    const gapdom = <div style={{ width: 5 }} />
    const Scroot = () => {
        return !load
            ? <div className="scedit_root" id='scedit_root'>

                {template_modal}
                {setting_modal}
                {edittable_modal}
                {addtable_modal}
                {addguest_modal}
                {editsingleguest_modal}
                {editseatedsingleguest_modal}
                {importdata_modal}
                {exportdata_modal}
                {help_modal}
                {qr_modal}
                {addcat_modal}
                {addrela_modal}
                {addgrp_modal}
                {[
                    // Arrange Seat
                    <div className="planning_topbar" >
                        <div className="scedit_dlimportsavehidden">{exportbtn}{gapdom}{importbtn}</div>
                        {backicon}
                        {guestoreditorbtn}
                        <div className="scedit_dlimportsave">{exportbtn}{gapdom}{importbtn}</div>
                    </div>,
                    // Design
                    <div className="planning_topbar" >
                        <div className="scedit_dlimportsavehidden"> {savebtn}</div>
                        {backicon}
                        {guestoreditorbtn}
                        <div className="scedit_dlimportsave"> {savebtn}</div>
                    </div>,
                    // Online
                    <div className="planning_topbar" >
                        <div className="scedit_dlimportsave" style={{ opacity: 0, left: 10, userSelect: 'none', pointerEvents: 'none' }} />
                        {backicon}
                        {guestoreditorbtn}
                        <div className="scedit_dlimportsave" />
                    </div>,
                    <div className="planning_topbar" >
                        <div className="scedit_dlimportsave" style={{ opacity: 0, left: 10, userSelect: 'none', pointerEvents: 'none' }} />
                        {backicon}
                        {guestoreditorbtn}
                        <div className="scedit_dlimportsave" />
                    </div>
                ][mode]}
                {[
                    <div className="scedit_bottom">
                        <DragDropContext onDragEnd={onDragEnd}>
                            {RIGHT}
                            {LEFT}
                        </DragDropContext>
                    </div>,
                    <Scdesign
                        tableobjs={tableobjs}
                        guests={guests}
                        pages={pages}
                        updatePages={(pgs, savebool) => {
                            setPages(Object.assign(pgs, {}))
                            if (pages.length === 0) { // if user first time in, set all to default for Online
                                var data = Extractpageprops(pgs[parseInt(0, 10)], 0)
                                if (data) {
                                    data['onlinemaintxtliner'] = 0 // 0 - oneliner 1 - twoliner
                                    setOnlineselectedpgprops(Object.assign(data, {}))
                                    setOnlineselectedpg(parseInt(0, 10))
                                }
                            }
                        }}
                        save={(newpages) => {
                            Savefunc(guests, tableobjs, newpages)
                        }}
                    />,
                    <Online
                        tableobjs={tableobjs}
                        pages={pages}
                        guests={guests}
                        onlineselectedpg={onlineselectedpg}
                        updateOnlineselectedpg={(val, onlinemaintxtliner) => {
                            var data = Extractpageprops(pages[parseInt(val, 10)], onlinemaintxtliner)
                            data['onlinemaintxtliner'] = onlinemaintxtliner // 0 - oneliner 1 - twoliner
                            setOnlineselectedpgprops(Object.assign(data, {}))
                            setOnlineselectedpg(parseInt(val, 10))
                            setOnlineselectedsave(true)
                        }}
                        changetodesignmode={() => setMode(1)}
                        openqr={() => { setShowqr(true) }}
                    />,
                    <Seatlayout />
                ][mode]}
                <Noti noti={noti} />
                {/* <Jfmodal
                    show={bannermod}
                    onHide={() => { setBannermod(false) }}
                    title={'Select Banner'}
                    device={device}
                    content={
                        <div className="Qr_bannermodal">
                            <Banners
                                select={({ index }) => { setImgs([banners[index], flowers[index], imgs[2]]); setBannermod(!bannermod); }}
                                selected={imgs[0]}
                                banners={banners}
                                names={bannernames}
                            />
                        </div>
                    }
                /> */}
                {returnhome
                    ? <Modcfm
                        onHide={() => { setReturnhome(false) }}
                        onOk={() => { props.history.push(PLOBJ['seatingchart']['toolurl']) }}
                        onNo={() => { setReturnhome(false) }}
                        txt={'You are returning to planning tools menu.'}
                    />
                    : null}

                {showsave
                    ? <div className='Rsvpqnexplorer_swappedsavedroot' >
                        <button
                            id='Scedit_cancelbtn'
                            className='Rsvpqnexplorer_swappedcancel'
                            onClick={() => {
                                const { guests, tableobjs } = beforeswapdata
                                setShowsave(false)
                                setSwapmade(false)
                                setGuests(guests.slice())
                                setTableobjs(tableobjs.slice())
                                setMassmoveguests([])
                                closeallpopups()
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            className='Rsvpqnexplorer_swappedsavedbtn'
                            onClick={() => {
                                try {
                                    axios({
                                        method: 'POST',
                                        url: UPDATE_SWAP,
                                        headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                                        data: { scid, urlhandler, save_id, passcode, guests, tableobjs }
                                    }).then((item) => {
                                        const { message, new_saveid } = item.data
                                        if (message === 'SUCCESS') {
                                            setSwapmade(false)
                                            setShowsave(false)
                                            setSave_id(new_saveid)
                                            setBeforeswapdata({})
                                            closeallpopups()
                                        }
                                        else {
                                            alert('expired')
                                        }
                                    }).catch((e) => {
                                        console.log(e)
                                    })
                                }
                                catch (e) { console.log(e) }
                            }}
                        >
                            Save
                        </button>

                    </div>
                    : null}
            </div>
            : null
    }

    return firsttime && !load
        ? <Loading />
        : device === 'MOBILE'
            ? Nomobile()
            : Scroot()

}

export default Seatchartedit

function Translate_id_to_obj(massmoveguests, massmoveguestsobjs, guestobjs) {
    for (let i = 0; i < massmoveguests.length; i++) {
        const id = massmoveguests[i]
        massmoveguestsobjs.push(guestobjs[id])
    }
}

function Remove_guests_and_create_guestobj(massmoveguests, local_tableobjs, local_guests, guestobjs) {

    for (let i = 0; i < massmoveguests.length; i++) {
        const id_of_guest = massmoveguests[i]
        for (let j = 0; j < local_tableobjs.length; j++) {
            const { guests } = local_tableobjs[j]
            for (let k = 0; k < guests.length; k++) {
                const { id } = guests[k]
                if (id === id_of_guest) {
                    guestobjs[id] = guests[k]
                    local_tableobjs[j]['guests'].splice(k, 1)
                    k = 0
                }
            }
        }
    }

    for (let i = 0; i < massmoveguests.length; i++) {
        const id_of_guest = massmoveguests[i]
        for (let j = 0; j < local_guests.length; j++) {
            const { id } = local_guests[j]
            if (id === id_of_guest) {
                guestobjs[id] = local_guests[j]
                local_guests.splice(j, 1)
                j = 0
            }
        }
    }


}
